var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddresIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.4333V11.4333C8.61917 11.4333 7.5 10.3142 7.5 8.93335V8.93335C7.5 7.55252 8.61917 6.43335 10 6.43335V6.43335C11.3808 6.43335 12.5 7.55252 12.5 8.93335V8.93335C12.5 10.3142 11.3808 11.4333 10 11.4333Z",
    stroke: "url(#paint0_linear_549_40396)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 18.1001C10.0001 18.1001 4.16675 13.3084 4.16675 8.93343C4.16675 5.71176 6.77841 3.1001 10.0001 3.1001C13.2217 3.1001 15.8334 5.71176 15.8334 8.93343C15.8334 13.3084 10.0001 18.1001 10.0001 18.1001Z",
    stroke: "url(#paint1_linear_549_40396)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_549_40396",
    x1: 8.625,
    y1: 6.43335,
    x2: 11.7141,
    y2: 6.81708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38B97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4904D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_549_40396",
    x1: 6.79175,
    y1: 3.1001,
    x2: 14.0431,
    y2: 3.80071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38B97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4904D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddresIcon);
export default __webpack_public_path__ + "static/media/addres-icon.9f76ec0a7fac5d7a9a12311170c2fd5e.svg";
export { ForwardRef as ReactComponent };